import React from 'react';

const BlankLayout = ({ children }: { children?: React.ReactNode }) => (
  <div className="block h-dvh w-dvw bg-revamp-cobalt-400">{children}</div>
);

export default BlankLayout;
